import TreeList, { Column, Scrolling } from "devextreme-react/tree-list";

export const EditorView = (props: any) => {
  const { content } = props;

  const renderCell = (cellInfo: any) => {
    return <div style={{ whiteSpace: "normal" }} dangerouslySetInnerHTML={{ __html: cellInfo.value }} />;
  };

  return (
    content && (
      <TreeList
        id="content"
        dataSource={content}
        showRowLines={false}
        showBorders={false}
        showColumnHeaders={false}
        showColumnLines={false}
        columnAutoWidth={true}
        autoExpandAll={true}
        keyExpr="CustomId"
        parentIdExpr="CustomParentId"
      >
        <Scrolling mode="standard" />
        <Column
          fixed={true}
          fixedPosition="left"
          allowResizing={true}
          dataField="Content"
          alignment="left"
          dataType="string"
          cellRender={renderCell}
          cssClass="white-space: normal!important"
        />
      </TreeList>
    )
  );
};
